ApiError = require 'network/api-error'
Auth = require 'db/auth'
Controller = require 'controller'
Dates = require 'lib/dates'
emptyListTemplate = require 'views/templates/empty_list'
MemberCardsBoardsSectionView = require 'views/member/member-cards-boards-section-view'
MemberCardsFilterPopOverView = require 'views/member/member-cards-filter-pop-over-view'
MemberCardsGroupPopOverView = require 'views/member/member-cards-group-pop-over-view'
MemberCardsDateSectionView = require 'views/member/member-cards-date-section-view'
MemberCardsSortPopOverView = require 'views/member/member-cards-sort-pop-over-view'
MemberState = require 'view-models/member-state'
MemberView = require 'views/member/member-view'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
Util = require 'lib/util'
_ = require 'underscore'
t = require('views/internal/teacup-with-helpers')()
template = require 'views/templates/member_cards_base'
track = require 'debug/track'
moment = require 'moment'
l = require 'lib/localize'

daysAgo = (days) ->
  Date.now() - Util.getMs({ days })

activeInLast = (days) ->
  (card) ->
    Dates.parse(card.get('dateLastActivity')) > daysAgo(days)

filters =
  'active-day': activeInLast(1)
  'active-week': activeInLast(7)
  'active-month': activeInLast(30)
  'active-year': activeInLast(365)
  'all': (card) -> true

loadingTemplate = t.renderable ->
  t.div '.spinner.loading'

module.exports = class MemberCardsView extends MemberView
  initialize: ->
    super

    @_oldestLoaded = null
    @_loadedUnknown = {}

    @listenTo @model.boardList, 'add remove reset',
      @frameDebounce @renderMainContent

    @listenTo @model.organizationList, 'add remove reset change:memberships',
      @frameDebounce @renderMainContent

    @listenTo MemberState, 'change:cardsPageSortType change:cardsPageGroup', ->
      @renderCardsSection()

    @listenTo MemberState, 'change:cardsPageGroup', ->
      @_updateUrl()

    @listenTo MemberState, 'change:cardsPageFilter', ->
      @getData()

    Promise.try =>
      # Translate an org name to the id
      group =
        if @options.orgname
          @modelCache.findOne('Organization', 'name', @options.orgname)?.id

      group ?= @getSelectedGroup()

      isValidGroup = (group) =>
        if group in ['personal', 'all']
          return true

        org = @modelCache.get('Organization', group)
        org?.getMembershipFor(@model)? || group in @model.get('idOrganizations')

      if isValidGroup(group)
        group
      else
        # Maybe it's not valid because we haven't loaded the organization
        # memberships
        ModelLoader.loadOrganizationMembersMinimal group
        .then (org) ->
          if isValidGroup(group)
            group
          else
            'all'
    .then (group) =>
      if @getSelectedGroup() != group
        MemberState.setCardsPageGroup(group)

      if group != @options.orgname
        @_updateUrl()
    .done()

  events:
    'click .js-toggle-sort': 'toggleSort'
    'click .js-set-filter': 'toggleFilter'
    'click .js-set-group': 'toggleGroup'

  _updateUrl: ->
    group = @getSelectedGroup()
    url =
      if (org = @modelCache.get('Organization', group))
        Controller.getMemberCardsUrl(@model.get('username'), org.get('name'))
      else if group == 'personal'
        Controller.getMemberCardsUrl(@model.get('username'), 'personal')
      else
        Controller.getMemberCardsUrl(@model.get('username'))

    Controller.navigate(url, { replace: true })

  renderMainContent: ->
    @setActiveView('.js-member-cards')

    @$('.js-content').html(template({
      showGroup: @getSelectedGroup() != 'all' || @model.organizationList.length > 0
    }))

    @renderCardsSection()

    @

  getData: ->
    filter = @getFilterType()
    group = @getSelectedGroup()

    modifiedSince =
      switch filter
        when 'active-day' then daysAgo(1)
        when 'active-week' then daysAgo(7)
        when 'active-month' then daysAgo(30)
        when 'active-year' then daysAgo(365)
        else undefined

    oldest = daysAgo(365 * 40)
    newOldestLoaded = modifiedSince ? oldest

    showLoading = =>
      @loading = true
      @renderCardsSection()


    Promise.try =>
      if Auth.isMe(@model) || @_loadedMemberships
        return

      @_loadedMemberships = true

      showLoading()

      # If we're looking at another member, it's possible that the member
      # is deactivated on teams that we can see, and it's possible that
      # we're trying to see which cards they're still on
      me = Auth.me()

      ModelLoader.loadMyOrganizations()
      .then =>
        orgsWithDeactivation = me.organizationList.filter (org) ->
          org.isFeatureEnabled('deactivated')

        if orgsWithDeactivation.length == 0
          # We can't see any teams that have deactivation, so we don't need to
          # worry
          return

        ModelLoader.loadMemberOrganizationsDeactivatedMembers()
        .then =>
          if group == 'all'
            # See if we need to load cards from teams they've been deactivated on
            orgsToLoad = orgsWithDeactivation.filter (org) =>
              org.isDeactivated(@model)

            Promise.map orgsToLoad, (org) =>
              ModelLoader.loadOrgMemberCardData(org.id, @model.id)
              .then =>
                @_loadedUnknown[org.id] = true
            , { concurrency: 3 }
    .then =>
      # See if this is a member we wouldn't get cards for from
      # /member/:idMember/cards
      if Util.checkId(group)
        if @_loadedUnknown[group]
          return

        org = @modelCache.get('Organization', group)

        if !org? || org.isDeactivated(@model) || !org.getMembershipFor(@model)?
          showLoading()

          return ModelLoader.loadOrgMemberCardData(org.id, @model.id)
          .then =>
            @_loadedUnknown[org.id] = true
            # We can't date limit it, so we have all the cards
            @_oldestLoaded = oldest

      # See if we need to load more cards than we already have
      if !@_oldestLoaded? || @_oldestLoaded > newOldestLoaded
        showLoading()

        ModelLoader.loadMemberCards(@model.id, modifiedSince)
        .then =>
          @_oldestLoaded = newOldestLoaded

    .catch ApiError, =>
      # We shouldn't be getting errors, but it's possible that we did.
      # (e.g. right now there are cases where unconfirmed members get
      # a 401 when trying to read other board member's cards)
      # Rather than hanging, just render whatever we were able to load.
      return
    .then =>
      @loading = false
      @renderCardsSection()
    .done()

  getCards: ->
    filter = @getFilterType()
    group = @getSelectedGroup()

    @modelCache.find 'Card', (card) =>
      board = card.getBoard()

      card.isOpen() &&
      card.hasMember(@model) &&
      board?.isOpen() &&
      (
        switch group
          when 'all' then true
          when 'personal' then !board?.getOrganization()?
          else board?.get('idOrganization') == group
      ) &&
      (!filters.hasOwnProperty(filter) ||
        filters[filter](card))

  getSortType: -> MemberState.getCardsPageSortType()
  getFilterType: -> MemberState.getCardsPageFilter()
  getSelectedGroup: ->
    group = MemberState.getCardsPageGroup()
    if group in ['personal', 'all'] || (@modelCache.get('Organization', group))?
      group
    else
      'all'

  renderSortText: ->
    @$('.js-sort-text').html l(['sorting cards by', @getSortType()])
    @$('.js-filter-text').html l(['filtering cards by', @getFilterType()])

    group = @getSelectedGroup()

    @$('.js-group-text').html(
      if group == 'personal'
        l(['showing cards in group', 'personal'])
      else if group? && (org = @modelCache.get('Organization', group))?
        l(['showing cards in group', 'organization'], { name: org.get('displayName') })
      else
        l(['showing cards in group', 'all'])
    )

  toggleSort: (e) ->
    Util.stop(e)
    track("Member View", "Cards Page", "Open Sorting Options")

    PopOver.toggle
      elem: @$('.js-toggle-sort')
      view: new MemberCardsSortPopOverView({ @model, @modelCache })

    return

  toggleFilter: (e) ->
    Util.stop(e)
    track("Member View", "Cards Page", "Open Filtering Options")

    PopOver.toggle
      elem: @$('.js-set-filter')
      view: new MemberCardsFilterPopOverView({ @model, @modelCache })

    return

  toggleGroup: (e) ->
    Util.stop(e)
    track("Member View", "Cards Page", "Open Group Options")

    PopOver.toggle
      elem: @$('.js-set-group')
      view: new MemberCardsGroupPopOverView({ @model, @modelCache })

  clearContent: -> @$('.js-cards-content').empty()

  renderCardsSection: ->
    @clearContent()
    @renderSortText()

    if @loading
      @renderLoading()
    else
      switch @getSortType()
        when "board"
          @renderBoardSort()
        when "date"
          @renderDateSort()

    return

  _appendNoVisibleCards: ->
    text = if Auth.isMe(@model)
      l('no assigned cards.at all')
    else
      l('no assigned cards.that you can see')

    data =
      message: text
      classes: 'gutter'
      style: 'padding: 60px 10px;'

    @$('.js-cards-content').html(emptyListTemplate(data))

    return

  renderLoading: ->
    @$('.js-cards-content').html(loadingTemplate())

  renderBoardSort: ->
    cards = @getCards()

    hasCards = false

    # Can't use @model.boardList here, because deactivated users
    # won't have boards they're deactivated on in the list, and
    # we may be an admin looking at a deactivated user
    boards = _.chain(cards)
      .map (card) -> card.getBoard()
      .uniq()
      .compact()
      .filter (board) -> board?.isOpen()
      .sortBy (board) -> board.get('name').toLowerCase()
      .sortBy (board) -> if board.isStarred() then 0 else 1
      .value()

    for board in boards
      boardCards = _.filter(cards, (card) => card.get('idBoard') == board.id)
      key = _.chain(boardCards).pluck('id').sort().value().join(',')

      if !_.isEmpty(boardCards)
        hasCards = true
        sectionView = @subview MemberCardsBoardsSectionView, board,
          cards: boardCards
        , key
        @appendSubview(sectionView, @$('.js-cards-content'))

    if !hasCards then @_appendNoVisibleCards()

    @

  renderDateSort: ->
    dueIn = (min, max) ->
      start = moment().add(min, 'days')
      end = moment().add(max, 'days')
      (due, dueComplete) ->
        !dueComplete && moment(due).isBetween(start, end)

    cardDueDate = (card) ->
      sDue = card.get('due')
      if sDue? then Dates.parse(sDue) else null

    groupings =
      'overdue cards':
        fxTest: (due, dueComplete) ->
          !dueComplete && moment(due).isBefore(moment())
        data: { isOverdue: true }
      'due in the next day':
        fxTest: dueIn(0, 1)
        data: { isDueSoon: true }
      'due in the next 7 days':
        fxTest: dueIn(1, 7)
      'due in the next month':
        fxTest: dueIn(7, 28)
      'due later':
        fxTest: (due, dueComplete) ->
          !dueComplete && moment(due).isAfter(moment().add(28, 'days'))
      'due date met':
        fxTest: (due, dueComplete) -> dueComplete
      'cards with no due date':
        fxTest: (due) -> !due?
        data: { iconType: 'card' }

    # Somehow, if we pass null as one of the sort parameters, underscore
    # just freaks out and the collection is not sorted properly, hence the
    # defaulting.
    sortedCardsDue = _.sortBy(@getCards(), (card) => card.get('due') ? '')

    hasCards = false

    for header, { fxTest, data } of groupings
      groupedCards = sortedCardsDue.filter (card) =>
        fxTest(cardDueDate(card), card.get('dueComplete'))

      if !_.isEmpty(groupedCards)
        hasCards = true
        templateData = _.extend({ header: l(['card group headers', header]) }, data)
        sectionView = @subview(MemberCardsDateSectionView, Auth.me(), { templateData }, "datesectionview-#{header}")
        sectionView.groupedCards = groupedCards

        @appendSubview(sectionView, @$('.js-cards-content'))

    if !hasCards then @_appendNoVisibleCards()

    @



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-cards-view.coffee